/**
 * @fileoverview Sports theme - match sports and activity emojis.
 */

import { ThemeOptions } from '../../../services/ThemeService.js';
import { EmojiMatchingTheme } from '../../abstract/EmojiMatchingTheme.js';
import { allLabels } from '../../Labels.js';

/**
 * Sports theme with balls and athletic activities.
 */
export class SportsTheme extends EmojiMatchingTheme {
    constructor(options: ThemeOptions = {}) {
        super(
            'sports',
            'Sports',
            allLabels.sports,
            { numPairs: 4, isPremium: false, hasMovement: false, ...options }
        );
    }
}
